import { memo } from "react";

const ModalError = ({
  nameP,
  srcP,
  limitCompra,
  showModal,
  setShowModal,
}: {
  nameP: string;
  srcP: string;
  limitCompra: number;
  showModal: Boolean;
  setShowModal: (view: boolean) => void;
}) => (
  <div
    className={`modal fade ${showModal ? "show d-block" : ""}`}
    tabIndex={-1}
    role="dialog"
    style={showModal ? { backgroundColor: "rgba(0,0,0,0.5)" } : {}}>
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content bg-white">
        <div className="modal-header bg-danger d-flex justify-content-center">
          <h3 className="modal-title text-white">Límite alcanzado</h3>
        </div>
        <div className="modal-body text-center">
          <p className="develop___text p-1 mt-2">
            Has alcanzado el número máximo (
            <strong className="text-danger">{limitCompra}</strong>) de unidades
            para este producto: {nameP}
          </p>
          <div className="p-1">
            <img src={srcP} alt={nameP} className="rounded mx-auto d-block" />
          </div>
          <strong className="develop___text">
            {nameP ?? "Producto desconocido"}
          </strong>
        </div>
        <div className="modal-footer">
          <span
            className="btn btn-danger rounded-pill"
            style={{ fontSize: "18px" }}
            onClick={() => setShowModal(false)}>
            Cerrar
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default memo(ModalError);
